module.exports = __webpack_public_path__ + "static/img/login_bg.4a66a252.png";